import { render, staticRenderFns } from "./reuseComp.vue?vue&type=template&id=18131d87&scoped=true"
import script from "./reuseComp.vue?vue&type=script&lang=js"
export * from "./reuseComp.vue?vue&type=script&lang=js"
import style0 from "./reuseComp.vue?vue&type=style&index=0&id=18131d87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18131d87",
  null
  
)

export default component.exports